import React from 'react';
import { Link } from 'react-router-dom'

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';

import playscreen from './img/noasktask/noaskmedium.png';
import largeplayscreen from './img/noasktask/noasklarge.png';
import optionsscreen from './img/noasktask/noaskoptions.png';
import listscreen from './img/noasktask/noasklistlist.png';
import taskscreen from './img/noasktask/noasktasklist.png';
import timerscreen from './img/noasktask/noasktimer.png';
import rewardscreen from './img/noasktask/noaskrewards.png';
import appstorebadge from './img/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';


export const NoAskTask = ({}) => {





	return (
		<div className="container-fluid appdesc">
<div className="row padrow">
 <div className="col-md-8 col-lg-8">
			 <h2>No Ask Task List</h2>
 </div>
 <div className="col-md-4 col-lg-2">
 <div className="badgecontainer">
		 <a href='https://apps.apple.com/app/id1557050697'><img src={ appstorebadge } alt="Get in on App Store Badge" className="applebadge img-responsive d-block mx-auto badge"/></a>
</div>
 </div>
 <div className="col-md-4 col-lg-2">

 </div>

 </div>


<div className="row padrow">
<div className="col-md-12 col-lg-12">
			This is a combined visual schedule and timer with customizable rewards to help verbal and non-verbal children know what to expect throughout the day.
			 </div>
 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
			 <img src={ playscreen } alt="playing screen showing game in action" className="appimage readypic img-responsive img-thumbnail d-block mx-auto"/>
</div>

 </div>
 <div className="row padrow">
<div className="col-md-12 col-lg-12">
			Tasks added to the list can be in small, medium(above), large, or full-screen (below) format.
			 </div>
 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
			 <img src= {largeplayscreen } alt="Large play screen" className="appimage readypic img-responsive img-thumbnail d-block mx-auto"/>
</div>

 </div>

<div className="row padrow">
			 <div className="col-md-12 col-lg-12">
			 A visual timer can be used for each task, or for the list in total
 </div>
 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
       <img src= {timerscreen } alt="timer screen" className="appimage readypic img-responsive img-thumbnail d-block mx-auto"/>
 </div>

 </div>

 <div className="row padrow">
			 <div className="col-md-12 col-lg-12">
			Multiple lists can be added for various times through the day, or different daily schedules.
 </div>
 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
       <img src= {listscreen } alt="list screen" className="appimage readypic img-responsive img-thumbnail d-block mx-auto"/>
 </div>

 </div>
 <div className="row padrow">
			 <div className="col-md-12 col-lg-12">
			Standard reward icons can be used, or custom reward icons can be added if your child has a special interest.  Rewards can be displayed after each task or list and can spin or be staionary.
 </div>
 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
       <img src= {rewardscreen } alt="reward screen" className="appimage readypic img-responsive img-thumbnail d-block mx-auto"/>
 </div>

 </div>


 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
 Please let us know if you experience any issues are have any suggstions at our feedback form <Link to="/feedback" >
 here
 </Link>.</div>
 </div>


</div>

			)




}
